<script lang="ts" setup>
import ProductCategoryItem from '~/components/products/ProductCategoryItem.vue'
import ProductText from '~/components/products/ProductText.vue'
import type { ProductData } from '~/types/products'

const props = defineProps<{
  productData: ProductData
}>()

const categoriesData = computed(() => props.productData.relationships.categories.data)
</script>

<template>
  <div class="flex flex-col md:w-[calc(100%-24px-188px)]">
    <ProductText class="!mb-2 !ml-2 md:!mb-3" :text="'Ищут в\xA0категориях'" />

    <div class="relative -mr-2 max-w-full [&_*]:!cursor-grab [&_*]:select-none">
      <Carousel
        id="categories-carousel"
        class="!w-full !max-w-full whitespace-nowrap !p-0"
        drag-free
      >
        <div class="flex items-stretch">
          <ProductCategoryItem
            v-for="x in categoriesData"
            :key="x.id"
            :category-data="x"
            class="mr-2"
          />
        </div>
      </Carousel>
    </div>
  </div>
</template>

<style lang="scss">
#categories-carousel .embla-button {
  svg {
    fill: #202020 !important;
  }
}
</style>
